import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7ba9a1bc&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=7ba9a1bc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba9a1bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7ba9a1bc')) {
      api.createRecord('7ba9a1bc', component.options)
    } else {
      api.reload('7ba9a1bc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7ba9a1bc&scoped=true", function () {
      api.rerender('7ba9a1bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/insuranceManage/components/templateModal/index.vue"
export default component.exports